import colors from '../../_shared/colors';

export default {
  container: `
    align-items: center;
    justify-content: center;

    > span {
      width: 100%;
    }
  `,
  formContainer: `
    width: 600px;
    max-width: 600px;
  `,
  alertMargin: `
    margin-bottom: 40px;
  `,
  buttonContainer: `
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0;
  `,
  subText: `
    background-color: ${colors.disabledLight};
    font-size: 12px;
    text-align: left;
    padding: 2px 5px;
  `,
  button: `
    margin: 5px;
  `,
  // Card #267 — the driver-facing "Box Count" chip that sits under the Check In
  // Order button. Same treatment as the Print Labels button (a themed Button
  // used as an inline label with a small numeric Input inside it), so it picks
  // up the app's highlight colour without hard-coding a green.
  boxCountChip: `
    input {
      width: 70px;
      margin-left: 10px;
      text-align: center;
    }
  `,
  uploadContainer: `
    width: 80%;
  `,
  divider: `
    font-weight: bold;
    color: ${colors.highlight};
  `,
  dlTemplate: `
    position: absolute;
    left: 10px;
    top: 10px;
  `,
  row: `
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  column: `
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  // Card #256 round 2 — COD payment presentation pieces.
  // Disclaimer shown under the "Payment Required?" box while it is checked.
  paymentDisclaimer: `
    text-align: left;
    margin-top: 4px;
    font-size: 12px;
    color: ${colors.black};
    line-height: 1.5;
  `,
  // Notice rendered when the loaded order carries an admin payment override.
  // Round 3 — matches paymentDisclaimer (only the before-colon labels bold).
  paymentOverrideNotice: `
    text-align: left;
    margin-top: 8px;
    font-size: 12px;
    color: ${colors.black};
    line-height: 1.5;
  `,
  // Big driver-facing popup shown when COD enforcement blocks completing a
  // delivery (Danielle's Popup_Window mock: pink body, thick red border,
  // large bold black text).
  codBlockModal: `
    background-color: #f8c8d4;
    border: 6px solid ${colors.error};
    border-radius: 4px;
    padding: 40px 24px 32px 24px;
    text-align: center;
  `,
  codBlockTitle: `
    color: ${colors.black};
    font-size: 34px;
    font-weight: bold;
    line-height: 1.3;
    margin-bottom: 30px;
  `,
  codBlockSub: `
    color: ${colors.black};
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 30px;
  `,
  codBlockButton: `
    background-color: ${colors.error};
    border: 1px solid ${colors.error};
    color: ${colors.white};
    font-weight: bold;
    font-size: 16px;
    height: 40px;
    min-width: 140px;
  `,
}